import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from "@headlessui/react"
import { useRef, useContext, useEffect } from "react"
import { DisclosureContext } from "../Contexts"
import Chapters from "./Chapters"
import { classNames } from "../../lib"
import { focusVisibleRing } from "."
import { BookTitle } from "../../../chuukese-books/src"

const getRows = (chapters: number) => {
  const cols = 5
  const rows = Math.ceil(chapters / cols)
  return rows
}

const Book = ({ title, link, chapters }: { title: BookTitle; link: string; chapters: number }) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { setLastOpenDisclosure, closeRef } = useContext(DisclosureContext)

  const rows = getRows(chapters)

  useEffect(() => {
    if (ref.current) {
      if (ref.current.ariaExpanded === "true") {
        setLastOpenDisclosure(ref.current)
      }
    }
  }, [])

  return (
    <Disclosure>
      {({ open, close }) => (
        <>
          <DisclosureButton
            className={classNames(
              open ? "bg-slate-100" : "",
              focusVisibleRing,
              "h-10 w-full cursor-pointer px-5 text-center text-xl text-sky-700",
              "focus-visible:ring-2 focus-visible:ring-inset"
            )}
            ref={ref}
            onClick={() => {
              if (open) {
                // cache the currently open book's `close` action
                closeRef.current = close
              }
            }}
          >
            {title}
          </DisclosureButton>
          <Transition
            show={open}
            as="div"
            className="overflow-hidden"
            enter="transition transition-[max-height] duration-500 linear"
            enterFrom="transform max-h-0"
            enterTo={`transform max-h-[--chapter-row-height]`}
            leave="transition transition-[max-height] duration-200 ease-out"
            leaveFrom={`transform max-h-[--chapter-row-height]`}
            leaveTo="transform max-h-0"
            style={{
              ["--rows" as string]: rows,
              ["--chapter-row-height" as string]: "calc(3rem * var(--rows) * 2)",
            }}
          >
            <DisclosurePanel className="border-b" static>
              <Chapters chapters={chapters} link={link} title={title} bookButton={ref.current} />
            </DisclosurePanel>
          </Transition>
        </>
      )}
    </Disclosure>
  )
}

export default Book
